var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',{attrs:{"title":"Autores","titleIcon":"fas fa-feather-alt"}},[_c('catalogo-crud',{attrs:{"tipo":"autor","rotuloNovo":"NOVO AUTOR","nomeSingular":"autor","placeholderBusca":"Pesquisar por nome, forma de apresentação ou nacionalidade","campos":_vm.campos,"colunas":_vm.colunas}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }